import { createContext, useContext } from 'react';

/**
 * True when the open-fund form is running in "completion" (edit) mode — i.e. an applicant
 * returning via a secure link to complete a request that was marked Incomplete.
 * In this mode previously-uploaded documents are preserved server-side, so document upload
 * fields and add/remove-person controls are hidden; only the signature is re-captured.
 */
export const EditModeContext = createContext(false);

export const useEditMode = () => useContext(EditModeContext);
